import { useBundleLoader } from "../../core/bundle-loader";
import $ from "jquery";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/tab";
// TODO: Remove after transition to DsTooltip
import "bootstrap/js/dist/tooltip";
import { useVue } from "../../core/vue";
import { useScrollTo } from "@/shared/components/scroll-to-animated";
import { useWebpBackgroundImages } from "@sazka/utils/webp-background-images";
import { useCollapse } from "@sazka/utils/collapse";
import { Analytics } from "@/shared/utils/analytics/analytics";
import { useLazyLoading } from "@/shared/components/use-lazy-loading";
import { useVhUnitsCalculation } from "../../core/vh-units";
import { useGdpr } from "@/shared/gdpr/use-gdpr";
import { useGlobalVideoModal } from "@sazka/design-system/src/modal-video/mount-modal-video";
import { useEditableVideosGdprOverlay } from "@/shared/components/editable-videos-gdpr-overlay";
import { documentReady } from "@sazka/utils/document-ready";
import { useContactForm } from "./contact-form";
import { useHeader } from "./components/hsr-header";
import { setResponsibleGamingRootClass } from "./utils/responsible-gaming-class";

document.ready = (fn = () => {}) => documentReady(fn); // eslint-disable-line

window.dataLayer = window.dataLayer || [];

useBundleLoader().then(() => Analytics.bundlesLoaded());
useVue({ mountUserMenu: false, mountLegalWarning: false });
// register tmp global types
(window as any).$ = $;
(window as any).jQuery = $;

$(() => {
    useLazyLoading();
    useWebpBackgroundImages();
    useVhUnitsCalculation();
    useCollapse();
    useHeader();
    setResponsibleGamingRootClass();
    useGlobalVideoModal();
    useGdpr().init();

    useScrollTo();
    useEditableVideosGdprOverlay();
    useContactForm();

    // keep it last
    Analytics.domReady();
});
